import React from "react";
import InstantMeet from "src/components/instant-meet/InstantMeet";

export default function InstantMeetPage() {
  return <InstantMeet />;
}
